import React, { Component, Fragment } from 'react';
import { Typography, List, ListItem, ListItemText, ListItemSecondaryAction, Divider } from '@mui/material';
import Currency from '../common/Currency';
import { size } from "lodash";


class SubCategories extends Component {
    state = {  }
    render() {
        const { listSum, total, catLabels, listQty } = this.props;
        return (
            <List>
                <ListItem 
                    button
                >
                    <ListItemText 
                        primary={
                            <Typography >
                                Dépenses totales
                            </Typography>
                        } 
                    />
                    <ListItemSecondaryAction>
                        <ListItemText secondary={<Typography color="primary" ><Currency value={total} /></Typography>} />
                    </ListItemSecondaryAction>
                </ListItem>
                <Divider />
                {Object.keys(listSum).map( (catID, i) => {
                    return (
                        <Fragment key={catID}>
                            <ListItem 
                                button 
                                onClick={ () => this.props.handleCat(catID)}
                                
                            >
                                <ListItemText 
                                    primary={
                                        <Typography variant="body1">
                                            {catLabels[i]}
                                        </Typography>
                                    } 
                                    secondary={
                                        `${
                                            total > 0 
                                            ? Math.round(listSum[catID] / total * 100) 
                                            : 0
                                        }% - ${size(listQty[catID])} transaction${size(listQty[catID]) > 1 ? "s" : ""}`
                                    }
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText secondary={<Typography color="primary" variant="body2"><Currency value={listSum[catID]} /></Typography>} />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                        </Fragment>
                    )}
                )}
            </List>
                
        );
    }
}

export default SubCategories;